module.exports = "/static/Images/pt-br/Eight.png";